<template>
  <div :class="$style.container">
    <div :class="$style.pages">
      <router-link
        v-for="page in pages"
        :key="page"
        :to="page.link"
        :class="[$style.page]"
      >
        <p>{{ page.title }}</p>
        <!-- <div :class="$style.dev">
          <img src="/icons/warming.svg" alt="" />
        </div> -->
      </router-link>
    </div>
    <!-- <div :class="$style.descritipon">
      <img src="/icons/warming.svg" alt="" /> - страница в разработке
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      pages: [
        {
          title: "Контрагенты",
          link: "/counterparties",
        },
        {
          title: "ЛИДы",
          link: "/leads",
        },
        {
          title: "Проекты",
          link: "/projects",
        },
        {
          title: "Журнал событий",
          link: "/events-logs",
        },
      ],
    };
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 2rem 1rem;
  background-color: $bg-secondary;
  .title {
    margin: 0 0 1rem 0;
    @include H3;
  }
  .pages {
    display: flex;
    gap: 1rem;
    .page {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      padding: 1rem 0;
      width: 100%;
      background-color: $bg-main;
      cursor: pointer;
      border-radius: 0.5rem;
      text-align: center;
      @include Body1;
      &.disable {
        opacity: 0.6;
        cursor: auto;
        pointer-events: none;
      }
    }
  }
  .descritipon {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin: 1rem 0 0 0;
    @include Body1;
  }
}
</style>
